import { inject, observer } from "mobx-react";
import { ClientOverviewStore, ViewType } from "../../store/store";
import ToggleButtonsComponent from "../../../../components/toggle-button/ToggleButtonGroup";

import { ReactComponent as CardIcon } from "../../svg/card-view.svg";
import { ReactComponent as GridIcon } from "../../svg/grid-view.svg";
import { useTranslation } from "react-i18next";
import UserSettingsStore, {
    UserSettings,
} from "../../../../store/user-settings";

export interface ViewTogggleProps {
    userSettingsStore?: UserSettingsStore;
}

function ViewTogggle(props: ViewTogggleProps) {
    const userSettingsStore = props.userSettingsStore!;
    const viewType = userSettingsStore!.getUserSetting(
        UserSettings.RESIDENT_VIEW_TYPE
    );

    const { t } = useTranslation("client-grid");

    const buttons = [
        {
            id: ViewType.LIST,
            icon: <GridIcon width={16} />,
            tooltip: t("GridToggleButton"),
        },
        {
            id: ViewType.GRID,
            icon: <CardIcon width={16} />,
            tooltip: t("CardToggleButton"),
        },
    ];

    const render = () => {
        return (
            <ToggleButtonsComponent
                buttons={buttons}
                selectedID={viewType}
                onChange={(Id: string) => {
                    if (Id)
                        userSettingsStore.setUserSetting(
                            UserSettings.RESIDENT_VIEW_TYPE,
                            Id
                        );
                }}
            />
        );
    };
    return render();
}

export default inject("userSettingsStore")(observer(ViewTogggle));
